import { styled } from 'styled-components';
import { LIST_MAX_HEIGHT, ITEM_HEIGHT } from './constants.js';
export const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
export const InputWrapper = styled.div `
  display: flex;
  gap: 8px;
  align-items: ${({ $isTextareaMode }) => ($isTextareaMode ? 'flex-start' : 'center')};
  & > *:first-child {
    flex: auto;
  }
`;
export const ActionsColumn = styled.div `
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-shrink: 0;
`;
export const ListWrapper = styled.div `
  position: relative;
  overflow: hidden;
  border: ${({ $error, theme }) => `1px solid ${$error ? theme.colors.critical100 : theme.colors.grey30_1}`};
  border-radius: 8px;
  ${({ theme, $error }) => $error && theme.shadows.error};
  background-color: ${({ theme }) => theme.colors.grey00_7};
`;
export const ListHeader = styled.div `
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-items: center;
  ${({ theme }) => theme.typography.weightDefault};
  background-color: ${({ theme }) => theme.colors.grey05_1};
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.grey30_1}`};
  border-radius: 8px 8px 0 0;
`;
export const List = styled.div `
  width: 100%;
  min-height: ${({ $minHeight }) => ($minHeight ? `${ITEM_HEIGHT}px` : '0')};
  height: ${({ $selectedLength }) => $selectedLength * ITEM_HEIGHT}px;
  max-height: ${LIST_MAX_HEIGHT}px;
  overflow-y: auto;
`;
export const ListItem = styled.div `
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.grey10_1}`};
  background-color: ${({ theme, $isPlaceholder }) => ($isPlaceholder ? theme.colors.grey01_1 : theme.colors.grey00_6)};
  cursor: ${({ $isPlaceholder }) => ($isPlaceholder ? 'pointer' : 'default')};
`;
export const ListFooter = styled.div `
  ${({ theme }) => theme.typography.weightMedium};
  ${({ theme }) => theme.typography.textSmall};
  background-color: ${({ theme }) => theme.colors.grey01_1};
  border-top: 1px solid ${({ theme }) => theme.colors.grey30_1};
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  margin-top: -1px;
`;
export const Total = styled.div `
  color: ${({ theme }) => theme.colors.grey100_1};
`;
export const SortOrderWrapper = styled.div `
  cursor: pointer;
`;
export const Placeholder = styled.div `
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: center;
  padding: 8px;
  align-items: center;
  justify-content: center;
`;
export const Suggestions = styled.div `
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex-wrap: wrap;
  position: relative;
  min-height: 26px;
`;
